import PropTypes from 'prop-types'
import styled from 'styled-components'

import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

export const MyLoader = ({ width, height, type, iconHeight, iconWidth, withWrapper }) => {
  return (
    <Wrapper $width={width} $height={height} $withWrapper={withWrapper}>
      <Loader
        type={type || 'Oval'}
        color="rgba(255, 199, 0, 1)"
        secondaryColor="#1882FF"
        height={iconHeight || 100}
        width={iconWidth || 100}
        // timeout={10000} //10 secs
      />
    </Wrapper>
  )
}

MyLoader.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  type: PropTypes.string,
  iconHeight: PropTypes.string,
  iconWidth: PropTypes.string,
  withWrapper: PropTypes.bool
}

const Wrapper = styled.div`
  height: ${(props) => props.$height || '100vh'};
  width: ${(props) => props.$width || '100vw'};
  display: flex;
  align-items: center;
  justify-content: space-around;
  // if wrapper
  background-color: ${(props) => (props.$withWrapper ? 'rgba(255,255,255,0.8)' : '')};
  position: ${(props) => (props.$withWrapper ? 'fixed' : 'initial')};
  top: ${(props) => (props.$withWrapper ? '0' : 'initial')};
  z-index: 10;
`
